import { i18nMather } from '../utils';

const localThemeName = 'theme';
const localGridLayouts = 'grid_layout';
const localDismissNotice = 'dismiss_notice';
const localSelectedOU = 'selected_ou';
const localLatestAccount = 'latest_account';
const localLanguage = 'locale';
const localGroupOpenAccount = 'group_open_account';
const localRetentionUser = 'retention_user';
const localRedirectObj = 'redirect_Obj';
const localSelectedFsrTab = 'selected_fsr_tab'; // for multiple instances cluster/instance tabs
const localSelectedTipTab = 'selected_tip_tab'; // for multiple instances cluster/instance tabs

export const getLocalGridLayouts = () => {
  // for further version control could include version to name
  // const layoutStr = localStorage.getItem(localGridLayouts + version);
  const layoutStr = localStorage.getItem(localGridLayouts);
  if (layoutStr) {
    try {
      return JSON.parse(layoutStr);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const getLocalDismissNotice = () => {
  const noticeIDs = localStorage.getItem(localDismissNotice);
  if (noticeIDs) {
    try {
      return JSON.parse(noticeIDs);
    } catch (error) {
      return [];
    }
  }
  return [];
};

export const getLocalSelectedOU = () => {
  const ous = localStorage.getItem(localSelectedOU);
  if (ous) {
    try {
      return JSON.parse(ous);
    } catch (error) {
      return [];
    }
  }
  return [];
};

export const getLocalLatestAccount = () => {
  const account = localStorage.getItem(localLatestAccount);
  if (account) {
    try {
      return JSON.parse(account);
    } catch (error) {
      return {};
    }
  }
  return {};
};
export const getLocalGroupOpenAccount = () => {
  const account = localStorage.getItem(localGroupOpenAccount);
  if (account) {
    try {
      return JSON.parse(account);
    } catch (error) {
      return {};
    }
  }
  return {};
};

export const getLocalRedirectObj = () => {
  const obj = localStorage.getItem(localRedirectObj);
  if (obj) {
    try {
      return JSON.parse(obj);
    } catch (error) {
      return {};
    }
  }
  return {};
};

export const getLocalRetentionUser = () => {
  const theme = localStorage.getItem(localRetentionUser) || '';
  return theme;
};

export const updateLocalRetentionUser = (user: string) => {
  if (user) {
    localStorage.setItem(localRetentionUser, user);
  }
};

export const getLocalTheme = () => {
  const theme = localStorage.getItem(localThemeName) || '';
  return theme;
};

export const updateLocalTheme = (theme: string) => {
  if (theme) {
    localStorage.setItem(localThemeName, theme);
  }
};

export const getLocalLanguage = () => {
  const locale = localStorage.getItem(localLanguage);
  if (locale) {
    return locale;
  }
  // } else if (navigator.languages?.length) {
  //   const navigatorLanguage: string = navigator.languages[0];
  //   return i18nMather(navigatorLanguage);
  // }
  return 'auto';
};

export const updateLocalLanguage = (locale: string) => {
  if (locale) {
    localStorage.setItem(localLanguage, locale);
  }
};

export const getLocalSelectedFsrTab = () => {
  const tab = localStorage.getItem(localSelectedFsrTab) || '';
  return tab;
};

export const updateLocalSelectedFsrTab = (tab: string) => {
  if (tab) {
    localStorage.setItem(localSelectedFsrTab, tab);
  }
};

export const getLocalSelectedTipTab = () => {
  const tab = localStorage.getItem(localSelectedTipTab) || '';
  return tab;
};

export const updateLocalSelectedTipTab = (tab: string) => {
  if (tab) {
    localStorage.setItem(localSelectedTipTab, tab);
  }
};

export const updateLocalGridLayouts = (layout: any) => {
  let layoutStr = '';
  if (layout) {
    try {
      layoutStr = JSON.stringify(layout);
      // for further version control could include version to name
      // localStorage.setItem(localGridLayouts + version, layoutStr);
      localStorage.setItem(localGridLayouts, layoutStr);
    } catch (error) {
      console.warn('JSON stringify GridLayout error', error, layout);
    }
  }
};

export const updateLocalDismissNotice = (id: string) => {
  if (id) {
    try {
      const currentNoticeIds = getLocalDismissNotice();
      const newNoticeIds = [...currentNoticeIds, id];
      localStorage.setItem(localDismissNotice, JSON.stringify(newNoticeIds));
    } catch (error) {
      console.warn('JSON stringify noticeIds error', error, id);
    }
  }
};

export const updateLocalSelectedOU = (node: Record<string, any>) => {
  if (node) {
    try {
      localStorage.setItem(localSelectedOU, JSON.stringify(node));
    } catch (error) {
      console.warn('JSON stringify noticeIds error', error, node);
    }
  }
};

export const updateLocalLatestAccount = (account: Record<string, any>) => {
  if (account) {
    try {
      localStorage.setItem(localLatestAccount, JSON.stringify(account));
    } catch (error) {
      console.warn('JSON stringify noticeIds error', error, account);
    }
  }
};

export const updateLocalGroupOpenAccount = (account: Record<string, any>) => {
  if (account) {
    try {
      localStorage.setItem(localGroupOpenAccount, JSON.stringify(account));
    } catch (error) {
      console.warn('JSON stringify noticeIds error', error, account);
    }
  }
};

export const updateLocalRedirectObj = (obj: Record<string, any>) => {
  if (obj) {
    try {
      localStorage.setItem(localRedirectObj, JSON.stringify(obj));
    } catch (error) {
      console.warn('JSON stringify noticeIds error', error, obj);
    }
  }
};

export const deleteLocalSelectedOU = () => {
  localStorage.removeItem(localSelectedOU);
};

export const deleteLocalRetentionUser = () => {
  localStorage.removeItem(localRetentionUser);
};

export const deleteLocalSelectedFsrTab = () => {
  localStorage.removeItem(localSelectedFsrTab);
};
export const deleteLocalSelectedTipTab = () => {
  localStorage.removeItem(localSelectedTipTab);
};
